module.exports = __webpack_public_path__ + "img/check-icon-gray.048b30c0.svg";